<div class="resource-label-container">
	<div class="title-row">
		<span
			class="resource-title"
			[class.freya-link-button]="asset || template"
			(click)="openDetails()"
		>
			<ng-container *ngIf="asset; else useTitle">
				{{ asset.name }}<span *ngIf="asset.type"> ({{ asset.type }})</span>
				<p
					class="details"
					style="color: #999; font-size: 0.9em; margin-bottom: 7px"
					*ngIf="asset.description"
				>
					<i
						*ngIf="getIcon(asset.type)"
						[class]="getIcon(asset.type)"
					></i> {{ asset.description }}
				</p>
			</ng-container>
			<ng-template #useTitle>
				<span>{{ title }}</span>
			</ng-template>
		</span>

		<span
			*ngIf="template"
			class="freya-remove-availability-button"
			(click)="onRemove($event)"
		>
			<i class="pi pi-trash"></i>
		</span>
	</div>

	<div
		class="common-crew-list"
		*ngIf="showCrew && sortedCommonCrew?.length"
	>
		<app-crew-list
			[crew]="sortedCommonCrew"
			layout="column"
		></app-crew-list>
	</div>
</div>